import api from "@/services/api";

class BaseService{
    put(uri, data){
        return api
            .put(uri, data)
            .then((response) => {
                return response;
            });
    }
    destroy(uri, data){
        return api
            .delete(uri, data)
            .then((response) => {
                return response;
            });
    }
    get(uri, data){
        return api
            .put(uri, data)
            .then((response) => {
                return response;
            });
    }
}

export default BaseService;